"use strict";

export default class NavMenu {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    this.$dropdownBtn = $(".nav-menu__selected", this.$selector);

    this.$lvl1Link = $(".nav-menu__lvl1 > li", this.$selector);
    this.$lvl2Link = $(".nav-menu__lvl2 > li", this.$selector);
    this.$lvl1LinkMenu = $(".nav-menu__lvl1 > li > ul", this.$selector);
    this.$lvl2LinkMenu = $(".nav-menu__lvl2 > li > ul", this.$selector);

    this.isMobile = false;

    if (selfInit) this.init();
  }

  init() {
    this.checkMobileMode();
    this.stickyMenu();
    this.toggleMobileLabel();
    this.mobileCollapse();
    this.checkMenuPosition();
    this.toggleLevelOneLink(this.isMobile);
    this.toggleLevelTwoLink(this.isMobile);

    $(window).on("resize", () => {
      this.checkMobileMode();
      this.removeAll();
      this.checkMenuPosition();
      this.toggleLevelOneLink(this.isMobile);
      this.toggleLevelTwoLink(this.isMobile);
    });
  }

  checkMobileMode() {
    this.isMobile = $(window).width() < 1024;
  }

  stickyMenu() {
    $(window).on("scroll load", () => {
      let $headerHeight = $(".site-header").outerHeight();
      let navMenuPosition = this.$selector.offset().top;
      let currentScroll = $(window).scrollTop() + $headerHeight;

      if (currentScroll >= navMenuPosition) {
        this.$selector.addClass("sticky");
      } else {
        this.$selector.removeClass("sticky");
      }
    });
  }

  toggleMobileLabel() {
    this.$dropdownBtn.on("click", () => {
      this.$selector.toggleClass("expanded");
    });
  }

  toggleLevelOneLink(isMobile) {
    this.$lvl1Link.each((i, lvl1Link) => {
      $("> a[role='button']", $(lvl1Link)).off("click");
    });

    if (isMobile) {
      this.$lvl1Link.each((i, lvl1Link) => {
        $("> a[role='button']", $(lvl1Link)).on("click", (e) => {
          e.preventDefault();

          this.expandLevelTwo($(lvl1Link));
        });
      });
    }
  }

  toggleLevelTwoLink(isMobile) {
    this.$lvl2Link.each((i, lvl2Link) => {
      $("> a[role='button']", $(lvl2Link)).off("click");
    });

    if (isMobile) {
      this.$lvl2Link.each((i, lvl2Link) => {
        $("> a[role='button']", $(lvl2Link)).on("click", (e) => {
          e.preventDefault();

          this.expandLevelThree($(lvl2Link));
        });
      });
    }
  }

  checkMenuPosition() {
    $(this.$lvl1LinkMenu).map((i, lvl1LinkMenu) => {

      this.checkMenuExceedRight(lvl1LinkMenu);
    });

    $(this.$lvl2LinkMenu).map((i, lvl2LinkMenu) => {

      this.checkMenuExceedRight(lvl2LinkMenu);
    });
  }

  expandLevelTwo($level1) {
    if ($level1.hasClass("active")) {
      $level1.removeClass("active");
    } else {
      $(this.$lvl1Link).map((i, lvl1Link) => {
        if ($(lvl1Link).hasClass("active")) {
          $(lvl1Link).removeClass("active");
        }
      })
      $level1.addClass("active");
    }
  }

  expandLevelThree($level2) {
    if ($level2.hasClass("active")) {
      $level2.removeClass("active");
    } else {
      $(this.$lvl2Link).map((i, lvl2Link) => {
        if ($(lvl2Link).hasClass("active")) {
          $(lvl2Link).removeClass("active");
        }
      });
      $level2.addClass("active");
    }
  }

  mobileCollapse() {
    $(document).on("click", (e) => {
      if (
        !$(e.target).closest(this.$selector).length &&
        this.$selector.hasClass("expanded")
      ) {
        this.removeAll();
      }
    });
  }

  checkMenuExceedRight(ele) {
    let $ele = $(ele);
    let buffer = 100;
    let menuRightPos = $ele.offset().left + $ele.outerWidth();
    let menuWidth = this.$selector.outerWidth() - buffer;

    if (menuRightPos > menuWidth && !this.isMobile) {
      $ele.addClass("align-left");
    }
  }

  removeAll() {
    let $lvl1ActiveLink = $(".nav-menu__lvl1 > li.active", this.$selector);
    let $lvl2ActiveLink = $(".nav-menu__lvl2 > li.active", this.$selector);

    if ($lvl1ActiveLink.hasClass("active")) {
      $lvl1ActiveLink.removeClass("active");
    }
    if ($lvl2ActiveLink.hasClass("active")) {
      $lvl2ActiveLink.removeClass("active");
    }
    if (this.$selector.hasClass("expanded")) {
      this.$selector.removeClass("expanded");
    }
  }
}
